// extracted by mini-css-extract-plugin
module.exports = {"container":"_d3289e4c","wrapper":"_4971e798","iconWrapper":"_f2bd7e53","person":"_519d833e","professional":"_7cb3c360","divider":"_4d82c84a"};